import {Component, Input} from '@angular/core';
import {AnnotationHandler} from '../../annotation-handler';

@Component({
    selector: 'app-annotation-color-menu',
    templateUrl: './annotation-color-menu.component.html',
    styleUrls: ['./annotation-color-menu.component.scss'],
    standalone: false
})
export class AnnotationColorMenuComponent {

  @Input() curAnn: AnnotationHandler;
  @Input() isDialog: boolean;

  constructor() { }
}
